import { reactive } from "vue";
import axios from "axios";

let appElement = document.querySelector("#app");

const subscriptionType = appElement.getAttribute("data-subscriptionType");
const initCulture = appElement.getAttribute("data-culture");
const initWithInsurance = appElement.getAttribute("data-insurancechecked");
const paymentHeader = appElement.getAttribute("data-payment-header");
const paymentDescription = appElement.getAttribute("data-payment-description");
const formId = appElement.getAttribute("data-id");
const recruiters = appElement.getAttribute("data-recruiters");
const pageviewGuid = appElement.getAttribute("data-pageview-guid");
const devDictionary = window.location.href.includes("?dictionary=edit");

// Get recruiter from the CRM enrollment token payload (same channel as the rest of userDetails)
const tokenRecruiter = window.newMemberAppMerges?.userDetails?.recruiter;

// Validate if the recruiter exists in the recruiters list (case-insensitive)
const recruitersList = recruiters ? recruiters.split(",") : [];
const matchedRecruiter = tokenRecruiter
  ? recruitersList.find(r => r.toLowerCase() === tokenRecruiter.toLowerCase())
  : "";
const preselectedRecruiter = matchedRecruiter || "";

export const fetchedValues = {};

export function createStore(dictionary, priceList) {
  fetchedValues.dictionary = dictionary;
  fetchedValues.priceList = priceList;
  
  return reactive({
    subscriptionType: subscriptionType,
    currentCulture: initCulture,
    formId: formId,
    pageviewGuid: pageviewGuid,
    preselectedRecruiter: preselectedRecruiter,
    dk: createFormState("dk", subscriptionType, dictionary, priceList),
    en: createFormState("en", subscriptionType, dictionary, priceList),
  });
}

function createFormState(culture, subscriptionType, dictionaryData, priceListData) {
  //
  // This endpoint /umbraco/api/signup/GetSignupTextItems/?dictionaryKey=signupflow gets and caches the
  // titles and errors serverside (currently for 2 hours). This means that changes in the dictionary within
  // the CMS is not displayed right after the update.
  // This endpoint clears the cache - /umbraco/api/signup/ClearTextItemsCache/?dictionaryKey=signupflow
  //

  if (devDictionary) {
    axios.get("/umbraco/api/signup/ClearTextItemsCache/?dictionaryKey=signupflow");
  }

  // Method to query data from the endpoint
  const getItem = (key) => {
  const item = lang?.[culture]?.items?.[key];

  if (!item) {
    console.warn(`Missing item for key: "${key}" in culture: "${culture}"`);
    return ''; 
  }
  return devDictionary
    ? `###${item.item2}|${item.item1}###`
    : item.item2;
};
  //const getItem = (key) => (devDictionary ? `###${lang[culture].items[key].item2}|${lang[culture].items[key].item1}###` : lang[culture].items[key].item2);
  
  const lang = {
    en: dictionaryData?.languages.find((lang) => lang.language === "en-US"),
    dk: dictionaryData?.languages.find((lang) => lang.language === "da-DK"),
  };

  const productNameEn = subscriptionType == "student" ? "Student" : subscriptionType == "unemployed" ? "Unemployed" : "Employed";
  const productNameDa = subscriptionType == "student" ? "Studerende" : subscriptionType == "unemployed" ? "Ledig" : "I arbejde";

  let object = {
    // GLOBAL VALUE - NOT RESTRICTED TO LANGUAGE
    subscriptionType: "",
    dictionary: {

      insuranceHeader : getItem("SignupFlow.Insurance.Title"),
      insuranceDescription : getItem("SignupFlow.Insurance.Description"),
      insuranceLabel : getItem("SignupFlow.Insurance.Label"),
      insuranceHelpTip : getItem("SignupFlow.Insurance.HelpTip"),
      
      studentpricepromotionaldetail: getItem("SignupFlow.StudentPricePromotionalDetail"),

      showRecruiters: recruiters.length > 0,
      recruiters: recruiters.split(","),
      productName: culture == "dk" ? productNameDa : productNameEn,
      firstname: getItem("SignupFlow.Titles.Firstname"),
      lastname: getItem("SignupFlow.Titles.Lastname"),
      cpr: getItem("SignupFlow.Titles.Cpr"),
      nocpr: getItem("SignupFlow.Titles.NoCpr"),
      noCprHelperTip: getItem("SignupFlow.HelperTips.NoCprTip"), //
      nocprCountry: getItem("SignupFlow.Titles.Country"),
      nocprBirthDay: getItem("SignupFlow.Titles.Birthday"),
      nocprGender: getItem("SignupFlow.Titles.Gender"),
      emailaddress: getItem("SignupFlow.Titles.Email"),
      phonearea: culture == "dk" ? "+" : "(en)+",
      phone: getItem("SignupFlow.Titles.Phone"),
      personalInformationTitle: getItem("SignupFlow.Titles.PersonalInformation"),
      unionMember: getItem("SignupFlow.Titles.UnionMember"),
      unionUnsubscribe: getItem("SignupFlow.Titles.UnionUnsubscribe"),
      unionWhichOne: getItem("SignupFlow.Titles.UnionWhichOne"),
      uniondisclaimer: getItem("SignupFlow.Titles.UnionDisclaimer"), // OBS kun muligt for fagforeninger på listen.
      unemploymentInsuranceTitle: getItem("SignupFlow.Titles.UnemploymentInsuranceTitle"),
      unemploymentInsuranceMember: getItem("SignupFlow.Titles.UnemploymentInsuranceMember"),
      unemploymentInsuranceWhichOne: getItem("SignupFlow.Titles.UnemploymentInsuranceWhichOne"),
      cancel: getItem("SignupFlow.Titles.Cancel"),
      select: getItem("SignupFlow.Titles.Select"),

      unemploymentinsurancememberftfalabel: getItem("SignupFlow.UnemploymentInsurance.YesFtfa"), // "Ja, FTFa"
      unemploymentinsurancememberanotherlabel: getItem("SignupFlow.UnemploymentInsurance.YesAnother"), // "Ja, en anden A-kasse"
      unemploymentinsurancemembernonelabel: getItem("SignupFlow.UnemploymentInsurance.No"), // "Nej"
      unemployedWorkArea: getItem("SignupFlow.Titles.UnemployedWorkArea"),
      unemployedWorkFunction: getItem("SignupFlow.Titles.UnemployedWorkFunction"),

      generalYes: getItem("SignupFlow.Titles.Yes"), // "Ja"
      generalNo: getItem("SignupFlow.Titles.No"), // "Nej"

      unionmemberyeslabel: getItem("SignupFlow.Titles.Yes"), // "Ja"
      unionmembernolabel: getItem("SignupFlow.Titles.No"), // "Nej"
      unionsubscribeyeslabel: getItem("SignupFlow.Titles.Yes"), // "Ja"
      unionsubscribenolabel: getItem("SignupFlow.Titles.No"), // "Nej"
      unionmemberyeshelpertips: getItem("SignupFlow.HelperTips.UnionMemberYes"), // Du kan tegne indboforsikringen umiddelbart efter, du har afsluttet din indmeldelse.
      unionmembernohelpertips: getItem("SignupFlow.HelperTips.UnionMemberNo"), // Du kan tegne indboforsikringen umiddelbart efter, du har afsluttet din indmeldelse.

      educationLevelTitle: getItem("SignupFlow.Titles.EducationLevelTitle"), // "Hvad er din højeste uddannelse?"
      educationYourEducationTitle: getItem("SignupFlow.Titles.EducationYourEducationTitle"), // "Din uddannelse"
      educationradiohighereducation: getItem("SignupFlow.Titles.Education.HigherEducation"), // "Videregående uddannelse"
      educationradiovocationaleducation: getItem("SignupFlow.Titles.Education.Trainee"), // "Elev, erhvervsuddannelse"
      educationInstitutionsTitle: getItem("SignupFlow.Titles.EducationInstitutionsTitle"), // "Uddannelsessted"
      educationCurrentTitle: getItem("SignupFlow.Titles.EducationCurrentTitle"), // "Igangværende uddannelse"
      educationStarted: getItem("SignupFlow.Titles.EducationStarted"), // "Uddannelse startet"
      educationExpectedEnd: getItem("SignupFlow.Titles.EducationExpectedEnd"), // "Forventet slutdato"
      traineeStarted: getItem("SignupFlow.Titles.TraineeStarted"), // "Startdato elevperiode"
      traineeExpectedEnd: getItem("SignupFlow.Titles.TraineeExpectedEnd"), // "Slutdato elevperiode"

      unemploymentInsurancePreviousMemberLabel: getItem("SignupFlow.Titles.UnemploymentInsurancePreviousMember"), // Har du tidligere været medlem af en a-kasse?
      unemploymentInsuranceGraduateLabel: getItem("SignupFlow.Titles.UnemploymentInsuranceGraduateTitle"), // Er du dimittend/nyuddanet?
      unemploymentInsuranceClaimYourRightsLabel: getItem("SignupFlow.Titles.UnemploymentInsuranceClaimYourRights"), // Vil du have ret til dagpenge som nyuddannet, når du afslutter din uddannelse?
      unemploymentInsuranceClaimYourRightsHelperTip: getItem("SignupFlow.Titles.UnemploymentInsuranceClaimYourRightsInformation"), // Du skal svare ja, hvis du afslutter din uddannelse inden for de næste 2 måneder, eller hvis du har afsluttet din uddannelse indenfor de sidste 14 dage.
      unemploymentInsuranceDoYouAgreeLabel: getItem("SignupFlow.Titles.UnemploymentInsuranceDoYouAgree"), // Jeg ønsker gratis medlemskab og kan svare JA til at:
      unemploymentInsuranceDidYouLiveInDenmarkEducationStartLabel: getItem("SignupFlow.Titles.UnemploymentInsuranceDidYouLiveInDenmarkEducationStart"), // Havde du bopæl i Danmark, da du begyndte på uddannelsen?
      unemploymentInsuranceFulltimeParttimeLabel: getItem("SignupFlow.Titles.UnemploymentInsuranceFulltimeParttime"), // Jeg ønsker at være
      unemploymentInsuranceApplyForFreeMembershipLabel: getItem("SignupFlow.Titles.UnemploymentInsuranceApplyForFreeMembership"), // Jeg søger om gratis medlemskab under min uddannelse
      unemploymentInsuranceReceivingPublicBenefitsLabel: getItem("SignupFlow.Titles.UnemploymentInsuranceReceivingPublicBenefits"), // Jeg modtager offentlige ydelser, fx revalidering eller barselspenge, mv.
      unemploymentInsuranceBenefitsApartFromTraineeSalaryLabel: getItem("SignupFlow.Titles.UnemploymentInsuranceBenefitsApartFromTraineeSalary"), // Indtægter udover elevløn
      unemploymentInsuranceStudentSalaryThroughoutEducation: getItem("SignupFlow.Titles.UnemploymentInsuranceStudentSalaryThroughoutEducation"), // Hele uddannelsen er SU-berrettiget
      unemploymentInsuranceStudentSecureYourRights: getItem("SignupFlow.Titles.UnemploymentInsuranceStudentSecureYourRights"), // Vælg JA for at sikre din ret til dagpenge efter endt uddannelse - også selvom du i øjeblikket har job. Din dagpengeret kræver også, at du har været medlem i et år til den tid, og du husker at melde dig ledig på jobnet.dk. Har du været medlem i mindre end et år, har du ret til dagpenge en måned efter, du afslutter din uddannelse. Hvis du har haft en samlet indkomst fra arbejde på 243.996 kr. (2021) eller mere de sidste tre år, samtidig med du har været medlem af en a-kasse. For så kan det muligvis betale sig for dig IKKE at sikre din dagpengeret. Ring og spørg a-kassen på tlf.: 89 38 39 70
      unemploymentInsuranceStudentConfirmYourChoice: getItem("SignupFlow.Titles.UnemploymentInsuranceStudentConfirmYourChoice"), // Jeg bekræfter, at jeg har læst vejledningen om konsekvenserne af mit valg
      unemploymentInsuranceStudentConfirmYourChoiceNo: getItem("SignupFlow.Titles.UnemploymentInsuranceStudentConfirmYourChoiceNo"), // Vælger du <strong>NEJ</strong> til at sikre din dagpengeret, vil du have ret til dagpenge, når du har været medlem af a-kassen i 12 mdr. OG haft en samlet indkomst fra arbejde på 243.996 kr. (2021) fordelt over 12 mdr. inden for medlemsperioden. Ring til a-kassen for vejledning på 89 38 39 70.
      unemploymentInsuranceStudentDoYouAgree: getItem("SignupFlow.Titles.UnemploymentInsuranceStudentDoYouAgree"), // Jeg søger om gratis medlemskab og som studerende tjener jeg under 285.669 kr. pr. år (2023-satser). Inden jeg startede uddannelsen, havde jeg bopæl og ophold i Danmark. Jeg modtager ikke offentlig forsørgelse som fx. kontanthjælp, barselsdagpenge eller revalidering. SU må du godt få.

      unemploymentInsuranceStudentFreeMembership: getItem("SignupFlow.Titles.UnemploymentInsuranceStudentDoYouAgreeFreeMembership"), // Du har valgt at søge om gratis medlemskab. Betingelserne for at blive gratis medlem er, at du følger en uddannelse, der varer mindst 18 måneder, og giver ret til SU eller er en elevuddannelse. Du skal også have haft bopæl og ophold i Danmark inden du startede på uddannelsen. Bor eller studerer du i udlandet, gælder særlige regler. Ring til a-kassen på tlf.: 89 38 39 70
      unemploymentInsuranceStudentFreeMembershipBenefits: getItem("SignupFlow.Titles.UnemploymentInsuranceStudentFreeMembershipBenefits"), // Du kan ikke få gratis medlemskab, hvis du modtager forsørgelse fra det offentlige som fx revalidering, kontanthjælp, barselsdagpenge fra kommunen eller anden offentlig ydelse (ikke SU, da dette ikke betragtes som offentlig forsørgelse).

      unemploymentInsuranceStudentTraineeExtraIncome: getItem("SignupFlow.Titles.UnemploymentInsuranceStudentTraineeExtraIncome"), // Jeg tror, at jeg får indtægter ved siden af min elevløn
      unemploymentInsuranceStudentTraineeNoExtraIncome: getItem("SignupFlow.Titles.UnemploymentInsuranceStudentTraineeNoExtraIncome"), // Jeg tror ikke, at jeg får indtægter ved siden af min elevløn
      unemploymentInsuranceStudentExtraIncome: getItem("SignupFlow.Titles.UnemploymentInsuranceStudentExtraIncome"), // Jeg tror, jeg får indtægter over 231.864 kr. (2021-tal)  på et år. (SU + anden indtægt)
      unemploymentInsuranceStudentNoExtraIncome: getItem("SignupFlow.Titles.UnemploymentInsuranceStudentNoExtraIncome"), // Jeg tror ikke jeg får indtægter over 231.864 kr. (2021-tal) på et år. (SU + anden indtægt)

      unemploymentInsuranceStudentResidenceNotDk: getItem("SignupFlow.Titles.UnemploymentInsuranceStudentResidenceNotDk"), // Jeg tror ikke jeg får indtægter over 231.864 kr. (2021-tal) på et år. (SU + anden indtægt)

      unemploymentInsuranceFullyInsured: getItem("SignupFlow.Titles.UnemploymentInsuranceFullyInsured"), // Fuldtidsforsikret
      unemploymentInsurancePartlyInsured: getItem("SignupFlow.Titles.UnemploymentInsurancePartlyInsured"), // Deltidsforsikret
      unemploymentInsuranceFullyPartlyInsuredExplanation: getItem("SignupFlow.Titles.UnemploymentInsuranceFullyPartlyInsuredExplanation"), // Fuldtidsforsikret, Hvis du arbejder mere end 30 timer om ugen, skal du være fuldtidsforsikret. <strong>Deltidsforsikret</strong><br />Hvis du arbejder 30 timer om ugen eller mindre, kan du vælge at lade dig deltidsforsikre.

      companyAddSecondaryWorkArea: getItem("SignupFlow.Titles.AddSecondaryWorkArea"), // "Tilføj sekundært arbejdsområde"
      companyAddAnotherWorkArea: getItem("SignupFlow.Titles.AddAnotherWorkArea"), // "Tilføj endnu et arbejdsområde"
      companyPayByCompanyTitle: getItem("SignupFlow.Titles.PayByCompanyTitle"), // "Det ser ud til, at din arbejdsplads tilbyder løntræk"
      companyPayByCompany: getItem("SignupFlow.Titles.PayByCompany"), // "Vil du betale dit kontingent via løntræk?"
      companypaybycompanyyeslabel: getItem("SignupFlow.Titles.Yes"), // "Ja"
      companypaybycompanynolabel: getItem("SignupFlow.Titles.No"), // "Nej"
      companyName: getItem("SignupFlow.Titles.CompanyName"), // "Virksomhed"
      companyAddress: getItem("SignupFlow.Titles.CompanyAddress"), // "Virksomhedsadresse"
      companyPostalCode: getItem("SignupFlow.Titles.CompanyPostalCode"), // "Postnummer"
      companyWorkArea: getItem("SignupFlow.Titles.WorkArea"), // "Arbejdsområde"
      companyWorkFunction: getItem("SignupFlow.Titles.WorkFunction"), // "Arbejdsfunktion"

      searchNoResults: getItem("SignupFlow.Titles.SearchNoResults"), // "Indtast en el. flere karakterer for at søge."

      placeholdertextbox: getItem("SignupFlow.Placeholders.TextBox"), // "Indtast"
      placeholdernospace: getItem("SignupFlow.Placeholders.NoSpace"), // "Indtast uden mellemrum"
      placeholdernodash: getItem("SignupFlow.Placeholders.NoDash"), // "Indtast uden bindestreg"
      placeholderselectorsearch: getItem("SignupFlow.Placeholders.NoDash"), // "Indtast uden bindestreg"
      placeholderselectdate: getItem("SignupFlow.Placeholders.SelectDate"), // "Vælg dato"
      placeholderpromocode: getItem("SignupFlow.Placeholders.Promocode"), // "Kampagnekode"
      placeholderPickOrSearch: getItem("SignupFlow.Placeholders.PickOrSearch"), // "Vælg eller søg"
      placeholderTraineeCompanyName: getItem("SignupFlow.Placeholders.TraineeCompanyName"), // Indtast virksomhedens fulde navn.

      helpertipunemploymentinsurance: getItem("SignupFlow.HelperTips.UnemploymentListTip"), // "Obs: A-kasse-relateret hjælpetekst."
      helpertipunion: getItem("SignupFlow.HelperTips.UnionListTip"), // "Obs: Fagforenings-relateret hjælpetekst."
      educationEndDate: getItem("SignupFlow.HelperTips.EducationEndDate"), // "Hvis du ikke kender..."
      traineeWorkFunction: getItem("SignupFlow.HelperTips.TraineeWorkFunction"), // "Obs: Er du trainee, skal du melde dig ind som lønmodtager. Er du i tvivl kan du kontakte Finansforbundet på..."
      helperPayByCompany: getItem("SignupFlow.HelperTips.PayByCompany"), // "Med løntræk trækkes det månedlige... Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vestibulum auctor aliquet."
      helpertiprecentgraduate: getItem("SignupFlow.HelperTips.RecentGraduate"), // Du skal svare ja, hvis du afslutter din uddannelse inden for de næste 2 måneder, eller hvis du har afsluttet din uddannelse indenfor de sidste 14 dage.

      errorfirstname: getItem("SignupFlow.Errors.Firstname"), // "Indtast venligst et fornavn"
      errorlastname: getItem("SignupFlow.Errors.Lastname"), // "Indtast venligst et efternavn"
      errorforbiddencharacters: getItem("SignupFlow.Errors.ForbiddenCharacters"), // "Feltet indeholder tegn, der ikke er tilladt."
      errorcpr: getItem("SignupFlow.Errors.Cpr"), // "Indtast dit cprnummer"
      errorcprformat: getItem("SignupFlow.Errors.CprFormat"), // "Indtast venligst dit 10-cifrede cprnummer korrekt uden -"
      erroremail: getItem("SignupFlow.Errors.Email"), // "Indtast venligst en email"
      erroremailformat: getItem("SignupFlow.Errors.EmailFormat"), // "Indtast email i korrekt format"
      errorcompanyname: getItem("SignupFlow.Errors.CompanyName"), // "Husk at indtaste virksomhedsnavn."
      errorcompanyaddress: getItem("SignupFlow.Errors.CompanyAddress"), // "Indtast virksomhedsadresse."
      errorcompanypostalcode: getItem("SignupFlow.Errors.CompanyPostalCode"), // "Indtast virksomhedspostnummer."
      errorhighesteducation: getItem("SignupFlow.Errors.EducationHighest"), // "Vælg din højeste uddannelse."
      errorworkarea: getItem("SignupFlow.Errors.WorkArea"), // "Husk at vælge arbejdsområde"
      errorworkfunction: getItem("SignupFlow.Errors.WorkFunction"), // "Husk at vælge arbejdsfunktion"
      errorinformation: getItem("SignupFlow.Errors.Information"), // "Husk at vælge i hvilket sprog du ønsker information fra Finansforbundet"
      errorunemploymentinsurance: getItem("SignupFlow.Errors.UnemploymentInsurance"), // "Husk at vælge om du er medlem af en A-kasse eller ej."
      errorpaybycompany: getItem("SignupFlow.Errors.PayByCompany"), // "Husk at vælge, om du ønsker at betale via løntræk"
      erroreducation: getItem("SignupFlow.Errors.Education"), // "Vælg hvilken type uddannelse du er i gang med."
      erroreducationinstitution: getItem("SignupFlow.Errors.EducationInstitution"), // "Vælg din uddannelsesinstitution"
      erroreducationcurrent: getItem("SignupFlow.Errors.EducationCurrent"), // "Vælg den uddannelse du er i gang med."
      errorworkset: getItem("SignupFlow.Errors.WorkSet"), // "Husk at vælge både arbejdsområde og arbejdsfunktion."

      errorrecentgraduate: getItem("SignupFlow.Errors.RecentGraduate"), // "Husk af vælge om du er nyuddannet."
      errorgraduatesecurerights: getItem("SignupFlow.Errors.GraduateSecureRights"), // "Husk at vælge om du ønsker at sikre dine rettigheder."
      errorgraduatefreemembership: getItem("SignupFlow.Errors.GraduateFreeMembership"), // "Husk at svare på om du søger gratis medlemskab under uddannelse."
      errorgraduatefreemembershipincome: getItem("SignupFlow.Errors.GraduateFreeMembershipIncome"), // "Husk at svare på indtægt i forbindelse med gratis medlemskab."
      errorgraduateresidenceeducationstart: getItem("SignupFlow.Errors.GraduateResidenceEducationStart"), // "Husk at vælge om du boede i Danmark, da du startede på din uddannelse."
      errorgraduatepublicsupport: getItem("SignupFlow.Errors.GraduatePublicSupport"), // "Husk at svare på om du modtager offentlige ydelser."
      errorgraduatesupportentitled: getItem("SignupFlow.Errors.GraduateEntitledToSupport"), // "Husk at vælge om du uddannelse er SU-berretiget."

      errorunemploymentinsurancetype: getItem("SignupFlow.Errors.UnemploymentInsuranceType"), // "Husk at vælge om du ønsker fuldtids- eller deltidsforsikring."

      errorStudentInsurance: getItem("SignupFlow.Errors.StudentInsurance"), // "Vælg om du vil du have indboforsikring eller ej."

      errorSelectStartDate: getItem("SignupFlow.Errors.SelectStartDate"), // "Vælg startdato"
      errorSelectEndDate: getItem("SignupFlow.Errors.SelectEndDate"), // "Vælg slutdato"
      errorSelectExpectedEndDate: getItem("SignupFlow.Errors.SelectExpectedEndDate"), // "Vælg forventet slutdato"
      errorEndDateGreaterThanStartDate: getItem("SignupFlow.Errors.EndDateGreaterThanStartDate"), // "Slutdatoen skal ligge efter startdatoen."
      errorunion: getItem("SignupFlow.Errors.Union"), // "Du mangler at svare på om du er medlem af en fagforening"
      errorwhichunion: getItem("SignupFlow.Errors.WhichUnion"), // "Husk at indtaste navn på din fagforening."

      errorphonenocountrycode: getItem("SignupFlow.Errors.PhoneNoCountryCode"), // "Indtast venligst landekode"
      errorphonecountrycodetooshort: getItem("SignupFlow.Errors.PhoneCountryCodeTooShort"), // "Værdien må minimum være på 2 karakterer"
      errorphonecountrycodetoolong: getItem("SignupFlow.Errors.PhoneCountryCodeTooLong"), // "Værdien må maksimalt være på 3 karakterer"
      errorphonecountrynumeric: getItem("SignupFlow.Errors.PhoneCountryNumeric"), // "Indtast kun landekode med tal"
      errorphonenotrecognized: getItem("SignupFlow.Errors.PhoneFakeNumber"), // "Telefonnummeret er ikke anerkendt."
      errorphonelength: getItem("SignupFlow.Errors.PhoneLength"), // "Telefonnumre skal være mellem 6 og 12 cifre"
      errorphonenonum: getItem("SignupFlow.Errors.PhoneNoNum"), // "Indtast venligst dit telefonnummer"
      errorphonenumeric: getItem("SignupFlow.Errors.PhoneNumeric"), // "Indtast kun telefonnummer med tal"
      errornocprcountry: getItem("SignupFlow.Errors.Country"), // "Indtast- og vælg det land du kommer fra"
      errornobirthday: getItem("SignupFlow.Errors.Birthday"), // "Vælg venligst din fødselsdag
      errornogender: getItem("SignupFlow.Errors.Gender"), // "Vælg venligst dit køn
      erroreducationdurationnotcompatiblewithinsuranceTitle: getItem("SignupFlow.Errors.EducationDurationNotCompatibleWithInsuranceTitle"), // "For at blive medlem af FTFa, skal du uddannelse være af mindst 18 måneders varighed."
      erroreducationdurationnotcompatiblewithinsurance: getItem("SignupFlow.Errors.EducationDurationNotCompatibleWithInsurance"), // "For at blive medlem af FTFa, skal du uddannelse være af mindst 18 måneders varighed."

      headertitle: getItem("SignupFlow.Titles.HeaderTitle"), // "Meld dig ind!"

      promocodeusedtitle: getItem("SignupFlow.Titles.PromocodeUsedTitle"), // "Indløst kampagnekode:"
      promocodeusedtext: getItem("SignupFlow.Titles.PromocodeUsedText"), // "Du er blevet anbefalet af din kollega. I modtager begge et gavekort på 500 DKK til Magasin."
      promocodesubmittext: getItem("SignupFlow.Titles.PromocodeSubmitText"), // "Indløs"
      errorpromocode: getItem("SignupFlow.Errors.Promocode"), // "Kampagnekoden er ugyldig"

      consenttitle: getItem("SignupFlow.Consent.Title"), //"Samtykke",
      consentacceptall: getItem("SignupFlow.Consent.AcceptAll"), //"Accepter alle samtykker",
      consenttext: getItem("SignupFlow.Consent.Text"), //"Du kan altid trække samtykke tilbage ved at gå på ”Mit forbund” på Finansforbundets hjemmeside",
      consentinsurance: getItem("SignupFlow.Consent.Insurance"), //"A-kasse",
      consentinsurancetext: getItem("SignupFlow.Consent.InsuranceText"), //"Jeg giver hermed samtykke til, at Finansforbundet og FTFa må registrere, behandle og indbyrdes udveksle ovenstående oplysninger. Behandlingen sker med det formål, at indmelde mig i de nævnte foreninger/organisationer. Jeg erklærer hermed på tro og love, at oplysningerne er korrekte, og jeg er indforstået med reglerne for medlemskab i FTFa.",
      consentcancel: getItem("SignupFlow.Consent.Cancel"), //"Udmeldelse af anden fagforening",
      consentcanceltext: getItem("SignupFlow.Consent.CancelText"), //"Jeg giver samtykke til, at Finansforbundet må bruge mine oplysninger til a melde mig ud af min nuværende fagforening",
      consentautopay: getItem("SignupFlow.Consent.AutoPay"), //"Kontingent via løntræk ",
      consentautopaytext: getItem("SignupFlow.Consent.AutoPayText"), //"Betal mit kontingent via løntræk (hvis din arbejdsgiver tilbyder løntræk). Jeg giver derfor samtykke til at Finansforbundet må videregive oplysninger til min arbejdsgiver om mit navn, cpr-nr. og kontingentbeløb, til brug for kontingentafregning (gælder også eventuel gruppelivsordning via Finansforbundet).",
      consentmemberofferings: getItem("SignupFlow.Consent.MemberOfferings"), //"Information om medlemstilbud",
      consentmemberofferingstext: getItem("SignupFlow.Consent.MemberOfferingsText"), //"Jeg vil gerne modtage information fra Finansforbundet om medlemstilbud fra Finansforbundets samarbejdspartnere. Finansforbundet må kontakte mig via telefon, e-mail, sms og sociale medier.",
      consentebox: getItem("SignupFlow.Consent.eBox"), //"Information via e-Boks",
      consenteboxtext: getItem("SignupFlow.Consent.eBoxText"), //"Jeg vil gerne modtage information fra Finansforbundet via e-Boks og giver derfor samtykke til, at Finansforbundet må videregive oplysninger om mit navn og cpr-nr. til e-Boks.",
      consentarticles: getItem("SignupFlow.Consent.Articles"), //"Finansforbundets vedtægter",
      consentarticlesurl: getItem("SignupFlow.Consent.ArticlesUrl"), //"https://www.finansforbundet.dk/om-os/vedtaegter",
      consentGdprArticles: getItem("SignupFlow.Consent.ArticlesGdpr"), //"Persondatapolitik",
      consentGdprArticlesurl: getItem("SignupFlow.Consent.ArticlesGdprUrl"), //"/dk/persondatapolitik/",

      submitbuttonwithpayment: getItem("SignupFlow.Buttons.WithPayment"), //"Vælg betalingsaftale",
      submitbuttonwithoutpayment: getItem("SignupFlow.Buttons.WithoutPayment"), //"Bliv medlem",

      callussuffix: getItem("SignupFlow.Titles.CallUsSuffix"), // "på hverdage mellem 8.30 og 15.30"
      callushelplabel: getItem("SignupFlow.Titles.CallUsHelpLabel"), // "Har du brug for hjælp?"
      callusphonenumber: getItem("SignupFlow.Titles.CallUsPhonenumber"), // '32661370' : '+45 32661370', // "33266137"

      languagedetailslabel: "What language do you want to receive information in?", // "What language do you want to receive information in?""
      languagedetailsdanish: "Danish", // "Danish"
      languagedetailsenglish: "English", // "English"

      paymentdetailsterms: getItem("SignupFlow.Titles.PaymentDetailsTerms"),
      paymentdetailspaymentagreement: getItem("SignupFlow.Titles.PaymentDetailsTermsButton"), // "Betalingsatale", // "Betalingsaftale"
      paymentdetailsdisclaimer: getItem("SignupFlow.Titles.FirstFreeMonthsFree"), // "De første 3 måneder er gratis"
      paymentdetailsdisclaimerStudent: getItem("SignupFlow.Titles.StudyFree"), // "Dit medlemskab af fagforeningen er gratis..."
      paymentdetailsforpaymentnow: getItem("SignupFlow.Titles.ForPaymentNow"), //"Til betaling nu", // "Til betaling nu"

      modalheadline: getItem("SignupFlow.Titles.ContactUs"), // "Kontakt os"
      modaltext: getItem("SignupFlow.Titles.ErrorInSignup"), // "Det ser ud til at der er problemer med indmeldelsen. Kontakt os for hjælp til at komme videre. <br> Ring 32661370 på hverdage mellem 8.30 og 16.00"

      ftfaStudentIntro: getItem("SignupFlow.Titles.StudentIntroText"),
      ftfaMustAccept: getItem("SignupFlow.Titles.FtfaMustAccept"),
      ftfaFreeMemberWarnTrainee: getItem("SignupFlow.Titles.FtfaFreeMemberWarnTrainee"),
      ftfaFreeMemberWarnStudent: getItem("SignupFlow.Titles.FtfaFreeMemberWarnStudent"),
      ftfaEducationExpectedEnd: getItem("SignupFlow.Titles.FtfaEducationExpectedEnd"),
      ftfaNoMembershipOnPublicBenefits: getItem("SignupFlow.Titles.FtfaNoMembershipOnPublicBenefits"),
      submitFtfaWarning: getItem("SignupFlow.Titles.SubmitFtfaWarning"),
      // Situational dictionary items // student, employed, unemployed below

      // Header manchet
      headermanchet: getItem("SignupFlow.Titles.HeaderManchet"), // headermanchetemployed
      headermanchetstudent: getItem("SignupFlow.Titles.HeaderManchetStudent"), // "Vi byder dig velkommen med gratis medlemskab af fagforeningen i hele din studieperiode, hvis du læser en videregående uddannelse.",
      headermanchetunemployed: getItem("SignupFlow.Titles.HeaderManchetUnemployed"), //"Vi byder dig velkommen med 3 måneders gratis medlemskab af fagforeningen. Så længe du er ledig, betaler du nedsat kontingent.",

      paymentdetailsmanchetemployed: getItem("SignupFlow.Titles.PaymentDetailsManchetEmployed"), //"De første tre måneders fagforening er gratis.",
      paymentdetailsmanchetstudent: getItem("SignupFlow.Titles.PaymentDetailsManchetStudent"), //"De første tre måneders fagforening er gratis.",
      paymentdetailsmanchetunemployed: getItem("SignupFlow.Titles.PaymentDetailsManchetUnemployed"), //"De første tre måneders fagforening er gratis. Så længe du er ledig, betaler du nedsat kontingent.",

      // use this for single words and things that aren't needed in the dictionary. The word free isn't likely to change to something else, neither is the word for union or unemployment insurance
      free: culture == "dk" ? "Gratis" : "Free", //'Gratis' : 'Free',
      productpricesuffix: culture == "dk" ? "kr./md." : "DKK/month",
      union: culture == "dk" ? "Fagforening" : "Union",
      unemploymentinsurance: getItem("SignupFlow.Consent.Insurance") || (culture == "dk" ? "A-kassen A&Til" : "Unemployment Insurance fund A&Til"),
      education: culture == "dk" ? "Uddannelse" : "Education",
      callusprefix: culture == "dk" ? "Ring" : "Call", //"Ring"

      modalbutton: culture == "dk" ? "Luk" : "Close", // "Luk"
    },

    values: {
      memberNo : null,
      insuranceDetails: {
        homeInsurance: null
      },
      personalDetails: {
        firstname: "",
        lastname: "",
        cpr: "",
        nocpr: false,
        emailaddress: "",
        phonearea: "",
        phone: "",
        birthday: "",
        gender: "",
        country: "",
        unemploymentinsurance: "",
        unemploymentInsurancewhichone: "",
        oldUnemploymentinsurance: "", //TODO (usedToHaveUnemploymentInsurance in payload)
        oldUnemploymentInsurancewhichone: "", //TODO - should just map to unemploymentInsuranceCompany in payload
        dimStudent: "", //TODO recentGraduate (bool)
        dimRights: "", // TODO recentGraduateUseRights (bool)
        dimRightsNO: "", //TODO recentGraduateRejectRights (bool)
        dimStudentInDenmark: "", //TODO recentGraduateStartedInDK (bool)
        dimStudentFree: "", //TODO recentGraduateFree (bool)
        dimStudentPension: "", //TODO recentGraduatePension (bool)
        dimStudentSu: "", //TODO recentGraduateSU (bool)
        dimStudentYesno: "", // TODO recentGraduateYesNo (bool)
        unionmember: "",
        unionunsubscribe: "",
        unionwhichone: "",
        informationLanguage: "",
        isEducation: false,
        isTrainee: false,
        companyName: "",
        companyAddress: "",
        companyPostalCode: "",
        workSets: [{ area: null, function: null }],
        payByCompany: false,
        consents: [],
        unemployedWorkArea: "",
        unemployedWorkFunction: "",

        traineeCompanyName: "",
        traineeCompanyAddress: "",
        traineeCompanyPostalCode: "",
        traineeWorkAreas: "",
        traineeWorkFunctions: "",
        traineeStarted: null,
        traineeExpectedEnd: null,

        educationType: "",
        educationInstitution: null,
        educationCurrent: null,
        educationStarted: "",
        educationExpectedEnd: null,
        educationDurationApproved: false,
        educationIsEducation: "",
        educationIsTrainee: "",

        consent: false,
      },
      productDetails: {
        unionselected: true,
        unemploymentinsuranceselected: initWithInsurance == "True",
        promocodeused: false,
        promocode: "",
        priceunion: priceListData?.priceUnion,
        priceunemployment: priceListData?.priceUnemployment,
        monthsoffreeunion: priceListData?.monthsoffreeunion,
        paymentHeader: paymentHeader,
        paymentDescription: paymentDescription,
        subscriptiontype: subscriptionType,
        campaignText: "",
        recruiter: preselectedRecruiter,
        recruitmentState: "",
        // Standalone flag for CPH Sales staff (high turnover, not tracked as individual recruiters);
        // independent of the recruiter dropdown above.
        cphSales: false,
      },
      visualDetails: {
        showPayByCompany: false,
        showModal: false,
        showEducationProblemModal: false,
        showLoadingSpinner: false,
        disableSubmit: false,
      },
    },
  };
  return object;
}
